// Carry Roll Compare slice — saved scenarios for Compare screen.

import type { StateCreator } from 'zustand';
import type { SimulationRequest } from '@carry-roll/shared-types';

export interface SavedScenario {
  id: string;
  label: string;
  request: SimulationRequest;
}

export interface CompareSlice {
  scenarios: SavedScenario[];
  addScenario: (label: string, request: SimulationRequest) => void;
  removeScenario: (id: string) => void;
  clearScenarios: () => void;
}

export const createCompareSlice: StateCreator<CompareSlice, [], [], CompareSlice> = (set) => ({
  scenarios: [],
  addScenario: (label, request) =>
    set((state) => ({
      scenarios: [
        ...state.scenarios,
        { id: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, label, request },
      ],
    })),
  removeScenario: (id) => set((state) => ({ scenarios: state.scenarios.filter((s) => s.id !== id) })),
  clearScenarios: () => set({ scenarios: [] }),
});
